module.exports = __webpack_public_path__ + "static/link-linkphrases-do-2aed1ca43474a98218d7419de2556da9.png";